import nodeClient from "./node-client";

export const fetchBranches = async (query = "") => {
  const response = await nodeClient.post(
    `service/private/v0/list/branch?${encodeURI(query)}`
  );
  return response.data;
};

export const fetchTerminals = async (query = "") => {
  const response = await nodeClient.get(
    `/service/private/v0/list/terminal?${encodeURI(query)}`
  );
  return response.data;
};

export const fetchHealthStatus = async (query = "") => {
  const response = await nodeClient.get(`/service/protected/v0/branch/health`);
  return response.data;
};
